import {PageManager} from 'genesis-packages/core';
import './TERMS.scss';

export default class TERMS extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

}
